/**
 * @flow
 * @relayHash f6d50a1b1c32ed644756e461faa2a58d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AiChatConversationsQueryVariables = {||};
export type AiChatConversationsQueryResponse = {|
  +aiConversations: $ReadOnlyArray<{|
    +conversationId: string,
    +title: ?string,
    +updatedAt: ?any,
  |}>
|};
export type AiChatConversationsQuery = {|
  variables: AiChatConversationsQueryVariables,
  response: AiChatConversationsQueryResponse,
|};
*/


/*
query AiChatConversationsQuery {
  aiConversations {
    conversationId
    title
    updatedAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "aiConversations",
    "storageKey": null,
    "args": null,
    "concreteType": "AiConversation",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "conversationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "updatedAt",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AiChatConversationsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AiChatConversationsQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "AiChatConversationsQuery",
    "id": null,
    "text": "query AiChatConversationsQuery {\n  aiConversations {\n    conversationId\n    title\n    updatedAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8b8b60499ae23f44a36c464b194101da';
module.exports = node;
